import { createCommand } from "lexical";

export const INSERT_IMAGE_COMMAND = createCommand("INSERT_IMAGE_COMMAND");
